import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export var store = new Vuex.Store({
    state: {
        data: Array,
        paginatedData: Array,
        user:JSON.parse(localStorage.getItem('unk_cloud_user')) || null,
        profilePicThumbnail:null,
        profilePicThumbnailURL:'',
        profilePicThumbnailVessel:null,
        profilePicThumbnailURLVessel:'',
        fileUploadInfo:[],
        showSignOffPendingSeafarerList:null,
    },
    mutations: {
        setfileUploadInfo(state, info){
            state.fileUploadInfo = info;
        },
        setProfilePicThumbnail(state, newImage){
            state.profilePicThumbnail = newImage;
            state.profilePicThumbnailURL = URL.createObjectURL(newImage);
        },
        deleteProfilePicThumbnail(state){
            state.profilePicThumbnail = null;
            state.profilePicThumbnailURL = ''
        },
        setProfilePicThumbnailVessel(state, newImage){
            state.profilePicThumbnailVessel = newImage;
            state.profilePicThumbnailURLVessel = URL.createObjectURL(newImage);
        },
        deleteProfilePicThumbnailVessel(state){
            state.profilePicThumbnailVessel = null;
            state.profilePicThumbnailURLVessel = ''
        },
        login(state, user){
            state.user = user;
            if(user.rememberMe == true)
                localStorage.setItem("unk_cloud_user",JSON.stringify(user));        
        },
        logout(state){
            localStorage.setItem('unk_cloud_user', null);
            state.user = null;
        },
        updateUserInfo(state, data){
            state.user.name = data.name;
            state.user.telephone = data.telephone;
            state.user.address = data.address;
            state.user.location = data.location;

            localStorage.setItem("unk_cloud_user",JSON.stringify(state.user));
        },   
        setSignOffPendingSeafarerList(state, data){
            state.showSignOffPendingSeafarerList = data;
        }   
    },
    actions: {
        
    },
    modules: {
        
    },
})
